import { jsx as _jsx } from "react/jsx-runtime";
import React, {} from 'react';
import { Tag } from "antd";
export const ACTIVE_COLOR = '#87d068';
export const ACTIVE_MESSAGE = 'YES';
export const INACTIVE_COLOR = '#f2930c';
export const INACTIVE_MESSAGE = 'NO';
const ActiveStatusTag = ({ active, activeColor = ACTIVE_COLOR, activeMessage = ACTIVE_MESSAGE, inactiveColor = INACTIVE_COLOR, inactiveMessage = INACTIVE_MESSAGE }) => {
    const color = active
        ? activeColor
        : inactiveColor;
    const message = active
        ? activeMessage
        : inactiveMessage;
    return (_jsx(Tag, { color: color, variant: "solid", children: message }));
};
export default ActiveStatusTag;
